<template>
  <div>
    <!-- {{user.testStatus}} - {{step}} -  -->
    <div class="fill">
      <span v-if="step === 0">{{{'profile.test.noTest.text' | label}}}</span>
      <span v-if="step === 1">{{{'profile.test.smsSent.text' | label}}}</span>
      <span v-if="step === 2">{{{'profile.test.smsReceived.text' | label}}}</span>
      <span v-if="step === 3">{{{'profile.test.responseReceived.text' | label}}}</span>
      <span v-if="step !== 0">{{{'profile.test.reset.text' | label}}}</span>
    </div>
    <div class="mdl-button mdl-js-button mdl-button--raised ga-button" :class="classes1"
      v-on:click="startTest()" :disabled="step !== 0">
      {{'profile.test.button.startTest' | label}}
    </div>
    <div class="mdl-button mdl-js-button mdl-button--raised ga-button" :class="classes2"
      v-on:click="setSmsReceived()" :disabled="step !== 1">
      {{'profile.test.button.smsReceived' | label}}
    </div>
    <div class="mdl-button mdl-js-button mdl-button--raised ga-button" :class="classes3"
      v-on:click="checkResponseReceived()" :disabled="step !== 2">
      {{'profile.test.button.responseReceived' | label}}
    </div>
    <div class="mdl-button mdl-js-button mdl-button--raised ga-button" :class="classes4"
      v-on:click="resetTest()" :disabled="step === 0">
      {{'profile.test.button.reset' | label}}
    </div>            
  </div>
</template>

<script>
var actions = require('common/store/actions')
var getters = require('common/store/getters')
var api = require('api')
module.exports = {
  ready: function () {
    this.setClasses()
  },
  data: function () {
    return {
      step: 0,
      classes1: {},
      classes2: {},
      classes3: {},
      classes4: {}
    }
  },
  methods: {
    startTest: function () {
      if (this.step === 0) {
        this.$dispatch('loading', true)
        api.SendSMS.clientTest({action: 'startSmsTest'})
        .then(() => {
          // console.log('startSmsTest done')
          return this.refreshUser()
        }).catch(err => {
          console.error('startSmsTest error', err)
        }).finally(() => {
          this.$dispatch('loading', false)
        })
      }
    },
    setSmsReceived: function () {
      if (this.step === 1) {
        this.$dispatch('loading', true)
        api.SendSMS.clientTest({action: 'setSmsReceived'})
        .then(() => {
          // console.log('setSmsReceived done')
          return this.refreshUser()
        }).catch(err => {
          console.error('setSmsReceived error', err)
        }).finally(() => {
          this.$dispatch('loading', false)
        })
      }
    },
    checkResponseReceived: function () {
      if (this.step === 2) {
        this.$dispatch('loading', true)
        api.SendSMS.clientTest({action: 'checkResponseReceived'})
        .then(() => {
          // console.log('checkResponseReceived done')
          return this.refreshUser()
        }).catch(err => {
          console.error('checkResponseReceived error', err)
        }).finally(() => {
          this.$dispatch('loading', false)
        })
      }
    },
    resetTest: function () {
      if (this.step !== 0) {
        this.$dispatch('loading', true)
        api.SendSMS.clientTest({action: 'reset'})
        .then(() => {
          // console.log('reset done')
          return this.refreshUser()
        }).catch(err => {
          console.error('reset error', err)
        }).finally(() => {
          this.$dispatch('loading', false)
        })
      }
    },
    setClasses: function () {
      if (this.user.testStatus === 'noTest') {
        this.step = 0
        this.classes1 = {
          'mdl-button--colored': true,
          'stepDone': false
        }
        this.classes2 = {
          'mdl-button--colored': false,
          'stepDone': false
        }
        this.classes3 = {
          'mdl-button--colored': false,
          'stepDone': false
        }
        this.classes4 = {
          'mdl-button--colored': false
        }
      } else if (this.user.testStatus === 'smsSent') {
        this.step = 1
        this.classes1 = {
          'mdl-button--colored': false,
          'stepDone': true
        }
        this.classes2 = {
          'mdl-button--colored': true,
          'stepDone': false
        }
        this.classes3 = {
          'mdl-button--colored': false,
          'stepDone': false
        }
        this.classes4 = {
          'mdl-button--colored': true
        }
      } else if (this.user.testStatus === 'smsReceived') {
        this.step = 2
        this.classes1 = {
          'mdl-button--colored': false,
          'stepDone': true
        }
        this.classes2 = {
          'mdl-button--colored': false,
          'stepDone': true
        }
        this.classes3 = {
          'mdl-button--colored': true,
          'stepDone': false
        }
        this.classes4 = {
          'mdl-button--colored': true
        }
      } else {
        // responseReceived
        this.step = 3
        this.classes1 = {
          'mdl-button--colored': false,
          'stepDone': true
        }
        this.classes2 = {
          'mdl-button--colored': false,
          'stepDone': true
        }
        this.classes3 = {
          'mdl-button--colored': false,
          'stepDone': true
        }
        this.classes4 = {
          'mdl-button--colored': true
        }
      }
    },
    refreshUser: function () {
      // reload user data
      return api.User.profile({
        username: this.user.nickname
      }).then((result) => {
        this.setUser(result.data)
        return Promise.resolve()
      }).catch((err) => {
        this.$dispatch('show-error', err.data)
      })
    }
  },
  vuex: {
    getters: getters,
    actions: actions
  },
  watch: {
    '$store.state.user.testStatus': function () {
      this.setClasses()
    }
  }
}
</script>

<style scoped>
.ga-button { 
  margin-bottom: 5px;
}
.mdl-button.stepDone {
  background-color: #52757a;
  color: white;
}
</style>


// WEBPACK FOOTER //
// TestSmsForm.vue?1456813e